/**
 * Navigation permission helpers.
 *
 * Backend returns `nav_permissions_effective` on /auth/me:
 *   - null  → user sees everything their role allows (owner or no restriction)
 *   - []    → user sees nothing extra (only "show: true" items without `perm`)
 *   - [..]  → explicit allow-list of permission keys
 *
 * Owner role ALWAYS sees everything regardless of stored permissions.
 */
export function hasPermission(user, key) {
  if (!user) return false;
  if (user.role === "owner") return true;
  const eff = user.nav_permissions_effective;
  if (eff == null) return true;   // null = unrestricted
  return eff.includes(key);
}

/**
 * Filter an array of nav items by their `perm` key. Items without a `perm`
 * field are always shown (legacy "show: true" rules still apply).
 */
export function filterByPermission(items, user) {
  return items.filter((it) => {
    if (it.show === false) return false;
    if (!it.perm) return true;
    return hasPermission(user, it.perm);
  });
}
